import { PayloadAction } from '@reduxjs/toolkit';

import { AppState } from 'editor/src/store/app/types';
import { SlotFileSet } from 'editor/src/store/design/types';

/** Merges into one picture set, so a debounced name edit and a folder arriving from the
 *  host's library never overwrite each other's field. */
const updateSlotFileSetReducer = (
  state: AppState,
  { payload }: PayloadAction<{ id: string; patch: Partial<SlotFileSet> }>,
) => {
  const builder = state.slotLayoutBuilder;
  if (!builder) {
    return;
  }
  builder.draft.fileSets = builder.draft.fileSets.map((fileSet) =>
    fileSet.id === payload.id
      ? { ...fileSet, ...payload.patch, folders: { ...fileSet.folders, ...(payload.patch.folders ?? {}) } }
      : fileSet,
  );
};

export default updateSlotFileSetReducer;
